{
  "chatAlsoDriverQuestion": "Do you also drive vehicles in your fleet?",
  "chatAlsoDriverHint": "You can complete your driver profile after registration.",
  "chatAlsoDriverYes": "Yes, I also drive",
  "chatAlsoDriverNo": "No, I only manage the fleet",
  "chatEmailQuestion": "What is your email?",
  "chatEmailHint": "You'll use it to sign in to your account.",
  "chatPasswordQuestion": "Create a password",
  "chatPasswordHint": "At least 8 characters.",
  "chatNameQuestion": "What is your name?",
  "chatPhoneQuestion": "What is your mobile number?",
  "chatPhoneHint": "For contact about your fleet.",
  "chatOwnerTypeQuestion": "How do you operate?",
  "chatOwnerTypeHint": "Pick the option that matches your situation.",
  "chatNifQuestion": "What is your NIF?",
  "chatAddressQuestion": "What is your address?",
  "chatCmtvdeQuestion": "What is your CMTVDE?",
  "chatDobQuestion": "What is your date of birth?",
  "chatDobHint": "Use the DD/MM/YYYY format.",
  "chatCompanyNameQuestion": "What is the company name?",
  "chatNipcQuestion": "What is the company NIPC?",
  "chatLicenseQuestion": "What is the operator license?",
  "chatLicenseHint": "Format: number/year — e.g. 12345/2024.",
  "chatContinue": "Continue",
  "chatProgress": "{{current}}/{{total}}",
  "ownerTypeIndividual": "Self-employed / NIF",
  "ownerTypeCompany": "Company / NIPC",
  "nifLabel": "NIF (tax number)",
  "nifPlaceholder": "NIF (tax number)",
  "nifRequired": "NIF is required.",
  "nifInvalidLength": "NIF must have 9 digits",
  "nifInvalid": "Invalid NIF",
  "addressPlaceholder": "Address",
  "addressRequired": "Address is required.",
  "cmtvdePlaceholder": "CMTVDE number",
  "cmtvdeRequired": "CMTVDE is required.",
  "cmtvdeInvalid": "Invalid format (N+/YYYY).",
  "dobPlaceholder": "Date of birth",
  "dateOfBirthRequired": "Date of birth is required.",
  "registerTitle": "Register",
  "chooseRolePrompt": "Choose how to register: Driver or Fleet Owner. If you are both, register as Owner.",
  "driverButton": "Driver",
  "ownerButton": "Fleet Owner",
  "registerDriverTitle": "Driver Registration",
  "registerOwnerTitle": "Register as Fleet Owner",
  "loginInformation": "Login Information",
  "identification": "Identification",
  "driverDetails": "Driver Details",
  "companyInformation": "Company Information",
  "next": "Next",
  "back": "Back",
  "submitButton": "Submit",
  "registrationSuccessTitle": "Successfully registered!",
  "registrationSuccessMessage": "Please confirm your email to complete registration.",
  "okButton": "OK",
  "continue": "Continue",
  "employmentTitle": "Employment Information",
  "loadingEmploymentInfo": "Loading employment information...",
  "employmentDataFound": "We found your employment information:",
  "edit": "Edit",
  "retry": "Retry",
  "employmentFormIntro": "Please provide your employment information:",
  "companyName": "Company Name",
  "companyNameRequired": "Company name is required.",
  "companyNipc": "Company NIF/NIPC",
  "nipcError": "NIF/NIPC must contain 9 digits",
  "nipcInvalid": "Invalid NIPC",
  "companyEmail": "Company Email",
  "companyPhone": "Company Phone",
  "companyEmailOptional": "Company email (optional)",
  "companyPhoneOptional": "Company phone (optional)",
  "companyContactOr": "OR",
  "permissionsTitle": "App Permissions",
  "permissionsDescription": "To provide the best experience, we need the following permissions:",
  "notificationsPermissionTitle": "Notifications",
  "notificationsPermissionDescription": "To receive alerts and important information",
  "locationForegroundPermissionTitle": "Location (Foreground)",
  "locationForegroundPermissionDescription": "To show your current location on the map",
  "locationBackgroundPermissionTitle": "Location (Background)",
  "locationBackgroundPermissionDescription": "To continue tracking even when the app is closed",
  "locationBackgroundPermissionImportant": "Important: To receive notifications when you're stopped at the same location for a while, you need to select 'Allow all the time' in your device's location settings.",
  "permissionsFinish": "Finish",
  "ownerButtonDisabled": "Owner Registration Disabled",
  "driverButtonDisabled": "Driver Registration Disabled",
  "loadingRegistrationStatus": "Loading registration options...",
  "duplicateIdentityTitle": "Already registered",
  "duplicateIdentityMessage": "This information is already registered to an existing account. Please log in with that account instead of creating a new registration.",
  "goToLogin": "Log in",
  "recoverAccount": "Recover access",
  "requestAuthorizedClaim": "Ask support for help",
  "supportRequestTitle": "Ask support for help",
  "supportRequestIntro": "Share a contact number and briefly explain how we can help. Support may request documents later through an authenticated channel.",
  "supportRequestEmail": "Email",
  "supportRequestPhone": "Mobile number",
  "supportRequestDescription": "How can we help?",
  "supportRequestSubmit": "Send request",
  "supportRequestReceived": "We received your request. Support will contact you.",
  "supportRequestFailed": "We could not send the request. Please try again.",
  "supportRequestPhoneRequired": "Enter your mobile number.",
  "supportRequestEmailRequired": "Enter your email.",
  "supportRequestDescriptionRequired": "Briefly describe the request.",
  "supportAccountTitle": "Create your support account",
  "supportAccountIntro": "Create and confirm your account so support can continue reviewing your request. You do not need to enter the company number again.",
  "supportAccountName": "Full name",
  "supportAccountPassword": "Password",
  "supportAccountRequired": "Complete all fields to continue.",
  "supportAccountSubmit": "Create account",
  "supportAccountCreated": "Account created. Confirm your email so support can continue.",
  "supportAccountFailed": "We could not create the account. Please try again.",
  "cancel": "Cancel",
  "chatGreeting": "Hi! 👋 Welcome to AllDrivers.",
  "chatChoiceQuestion": "To get started: do you manage a fleet or drive?",
  "chatChoiceHint": "Takes less than 2 minutes — promise.",
  "chatChoiceOwner": "I manage a fleet 🚗",
  "chatChoiceOwnerAnswer": "I manage a fleet 🚗",
  "chatChoiceDriver": "I'm a driver 🧑‍✈️",
  "chatChoiceDriverAnswer": "I'm a driver 🧑‍✈️",
  "chatOwnerIntro": "Great! Let's create your fleet account. 🚗",
  "chatAccountCreatedBridge": "Account created! 🎉 Now let's set up your fleet.",
  "chatDriverIntro": "Let's create your driver account. 🧑‍✈️",
  "chatProfileRecoveryIntro": "Let's complete your account details. 🧑‍✈️",
  "chatDriverPhoneHint": "For contact about your work.",
  "chatPayerQuestion": "Who pays for your license?",
  "chatPayerHint": "You can change this later.",
  "chatCompanyQuestion": "Which company are you associated with?",
  "chatCompanyHint": "We look the company up by NIPC. If we find it, no contact details are needed.",
  "companyLookupFoundTitle": "We found this company",
  "companyLookupFoundMessage": "{{name}} (NIPC {{nipc}}). Is this the company you work for?",
  "companyLookupConfirmYes": "Yes, that's my company",
  "companyLookupConfirmNo": "No, I'll correct it",
  "companyLookupConfirmRequired": "Confirm this is the company you work for.",
  "companyLookupInviteMismatch": "The NIPC does not match the company in the invitation. Correct it before continuing.",
  "companyLookupConfirmedHint": "Company confirmed. You can continue.",
  "companyLookupLoading": "Checking company…",
  "companyLookupFailed": "We could not verify the company.",
  "companyContactHintUnknown": "We couldn't find this company. Fill in only one of the two fields: email or phone.",
  "companyContactRequired": "Provide a company email or phone number — we couldn't find this company.",
  "payerRequired": "Choose who pays.",
  "payerCompany": "My company pays",
  "payerSelf": "I pay for my own license",
  "chatProductQuestion": "What do you want to use?",
  "chatProductHint": "Pick one — other combinations stay in the dashboard.",
  "productRequired": "Choose a product.",
  "productOptionHours": "Hours logging",
  "productOptionGps": "GPS",
  "productOptionCombo": "Hours + GPS",
  "companyContactRequired": "Provide a company email or phone number.",
  "invitationFoundTitle": "We found an invitation",
  "invitationFoundMessage": "{{company}} already invited this email. Would you like to accept the invitation?",
  "invitationFoundDecline": "Continue without invitation",
  "invitationFoundAccept": "Accept invitation",
  "invitationLinkRequiredTitle": "Use the invitation link",
  "invitationLinkRequiredMessage": "An invitation exists for this email. Open the invitation link from your email to continue; we do not reveal invitation details here.",
  "outcomeC4Title": "We couldn't find that company yet",
  "outcomeC4Message": "{{company}} isn't on AllDrivers yet. We already sent an invitation to the contact you provided — you can also share the link directly.",
  "outcomeC3Title": "Waiting for approval",
  "outcomeC3Message": "{{company}} is already on AllDrivers — we notified the manager. Your access will activate as soon as they approve it.",
  "outcomeActiveTitle": "You're all set",
  "outcomeActiveMessage": "Your employment with {{company}} is active. You can start working now.",
  "outcomePendingInviteTitle": "Waiting for activation",
  "outcomePendingInviteMessage": "Your account is awaiting activation.",
  "outcomePendingLicenseTitle": "Waiting for activation",
  "outcomePendingLicenseMessage": "Your account is awaiting activation.",
  "outcomeContactTitle": "We couldn't find that company yet",
  "outcomeContactMessage": "{{company}} isn't on AllDrivers yet. We saved your contact and our team will reach out to the company — you can also share the link directly with the manager.",
  "outcomeFailedTitle": "We couldn't finish",
  "outcomeFailedMessage": "Something went wrong finishing your registration with {{company}}. Please try again or contact support.",
  "outcomeSelfPayHint": "Once the company approves, go to Settings → Pay for my own license to switch billing to yourself.",
  "outcomeShareCta": "Share with your manager",
  "outcomeContinue": "Go to Dashboard",
  "outcomeContactContinue": "View activation status",
  "companyContactPendingTitle": "Waiting for the company",
  "companyContactPendingBody": "The company has not activated your access yet. You can wait for the company or pay for your own license to continue now.",
  "companyContactPendingSelfPayTitle": "Continue without waiting",
  "companyContactPendingSelfPayBody": "If you chose company payment by mistake or no longer want to wait, switch to self-pay. You will only pay after choosing and confirming a plan.",
  "companyContactPendingSelfPay": "Pay for my own license",
  "companyContactPendingSelfPayError": "We could not switch to self-pay. Please try again.",
  "companyContactPendingWaitTitle": "Keep waiting for the company",
  "companyContactPendingWaitBody": "Share this link with the manager to speed up activation.",
  "companyContactPendingShare": "Share the link with your manager",
  "companyContactPendingLogout": "Log out",
  "captchaError": "We could not confirm you are human. Please try again.",
  "captchaFailed": "Verification failed. Please try again.",
  "appStoresTitle": "Get the AllDrivers app",
  "appStoresMessage": "Install the app and sign in with the same AllDrivers account. Do not create another account. If your email is not confirmed yet, confirm it first using the registration email.",
  "downloadApp": "Download the app",
  "appStoreOpenError": "The store could not be opened. Use the store button to try again.",
  "appStoreTrademarks": "Apple, the Apple logo and App Store are trademarks of Apple Inc. Google Play and the Google Play logo are trademarks of Google LLC.",
  "appStoreAndroid": "Google Play (Android)",
  "appStoreIos": "App Store (iPhone)",
  "appLandingTitle": "Get started with AllDrivers",
  "appLandingRegisterNow": "Register now",
  "appLandingManualCode": "Register here or install the app. Keep the code to enter during registration: installing through a store does not guarantee the code will be preserved.",
  "appLandingChecking": "Checking the referral code…",
  "appLandingInvalid": "This code is unavailable for new referrals. You can register normally without a referral.",
  "appLandingUnavailable": "The code could not be checked right now. Retry or choose to register without a referral.",
  "appLandingWithoutWarning": "If you complete registration without a referral, you cannot add it later.",
  "appLandingWithout": "Register without a referral",
  "appLandingMessageAndroid": "Install the app from Google Play. Your referral code travels with the install and is filled in when you sign up in the app.",
  "appLandingMessageIos": "Install the app from the App Store. After installing, come back to this page and tap “I already have the app — open it” to keep your referral code.",
  "appLandingStoresTitle": "Install the app",
  "appLandingStoresMessage": "Choose your phone's store.",
  "appLandingCodeLabel": "Your referral code",
  "appLandingCodeHelp": "Keep this code. If the app does not show it when you sign up, come back to this page and open the app with the button below.",
  "appLandingCopy": "Copy code",
  "appLandingCopied": "Code copied.",
  "appLandingCopyFailed": "Could not copy. Write down the code above.",
  "appLandingOpenApp": "I already have the app — open it",
  "appLandingContinueWeb": "Continue in the browser"
}
